export type StreamSourceIdsMap = Record<string, string[]>;

type SourceConfigSourceIds = {
  stream: { id: string };
  sourceIds: string[];
};

export const sourceConfigsToSourceIdsMap = (
  sourceConfigs?: SourceConfigSourceIds[] | null,
): StreamSourceIdsMap =>
  Object.fromEntries(
    (sourceConfigs ?? [])
      .filter((config) => config.sourceIds.length > 0)
      .map((config) => [config.stream.id, config.sourceIds]),
  );
